// Domain 06 — Infrastructure Security (RouteZero Security Operations Center, Taguig)
import u01 from './u01-security-fundamentals.js';
import u02 from './u02-privileged-access.js';
import u03 from './u03-ssh-local-users.js';
import u04 from './u04-vty-access.js';
import u05 from './u05-acl-fundamentals.js';
import u06 from './u06-standard-acl.js';
import u07 from './u07-extended-acl.js';
import u08 from './u08-acl-troubleshooting.js';
import u09 from './u09-layer2-threats.js';
import u10 from './u10-port-security.js';
import u11 from './u11-aaa-concepts.js';
import u12 from './u12-aaa-config.js';
import u13 from './u13-security-incidents.js';
import u14 from './u14-final.js';

export default {
  id: 'd06', number: '06', title: 'Infrastructure Security',
  tagline: 'Device hardening, SSH and VTY restrictions, standard and extended ACLs, port security, AAA with RADIUS and TACACS+, and security logging at RouteZero\'s Taguig SOC.',
  units: [u01, u02, u03, u04, u05, u06, u07, u08, u09, u10, u11, u12, u13, u14],
};
